// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__9xgvT","upload-rule":"style_upload-rule__5Ea29","error-message":"style_error-message__AiUjV"};